import { useState } from 'react';

const useModal = (initialIsOpen = false) => {
  const [isOpen, setIsOpen] = useState<boolean>(initialIsOpen);

  const open = () => {
    setIsOpen(true);
  };

  const close = () => {
    setIsOpen(false);
  };

  return { isOpen, open, close };
};

export default useModal;
